<template>
  <ion-page>
  <master-layout pageTitle="فراموشی کلمه عبور">
    <ion-card>
      <ion-card-header>
        <ion-card-header>
          <ion-img src="/assets/img/logo-land.png" class="login-img"></ion-img>
        </ion-card-header>
      </ion-card-header>
      <ion-card-content>
<!--         v-if="!send_code" class="ajax-form" data-action="sendResetCodeForPassword" data-response="sendResetCode">-->
        <div v-if="!send_code">
          <div class="mt-1">
          <label>شماره تلفن</label>
          <input v-model="phone" type="tel" name="phone" class="form-control">
          </div>
        <ion-button @click="getResetCode" expand="full" color="info" >ارسال کد</ion-button>
        </div>
        <div v-if="send_code">
          <div class="mt-2">
            <label>کد ارسالی را وارد کنید</label>
            <input type="text" v-model="code" name="code" class="form-control">
          </div>
          <div class="mt-2">
            <label>گذرواژه جدید</label>
            <input v-model="password" type="password" name="password" class="form-control">
          </div>
          <div class="mt-2">
            <label>تکرار گذرواژه</label>
            <input v-model="re_password" type="password" name="re_password" class="form-control">
          </div>
          <ion-button @click="submitResetCode" expand="full" color="success" >تغییر کلمه عبور</ion-button>
        </div>
      </ion-card-content>
    </ion-card>
  </master-layout>
  </ion-page>
</template>

<script>
import {
  IonCard, IonCardHeader, IonCardContent,IonPage,
  // toastController
} from "@ionic/vue";
// mapActions
import {mapActions} from "vuex";
import {useRouter} from 'vue-router';
import {showSystemNoti} from "@/shared/helper";
// import {showSystemNoti} from '@/shared/helper'

export default {
  components: {
    IonCard, IonCardHeader, IonCardContent,IonPage
  },
  data()
  {
    return {
      send_code : false,
      expire_time : null,
      phone : '',
      reset : false,
      code : '',
      password : '',
      re_password : '',

    };
  },
  computed: {

  },
  setup()
  {
    const router = useRouter();
    return {router};
  },
  methods: {
    ...mapActions("app", {
      sendResetCodeFunc: 'sendResetCodeFunc',
      submitResetCodeFunc : 'submitResetCodeFunc'
    }),
    async getResetCode()
    {
      const check = await this.sendResetCodeFunc(this.phone);
      if (check.ok)
      {
        this.send_code = true;
        this.expire_time = check.expire_time;
        let interval = setInterval(function(){
          let now = new Date();
          let expire_time = new Date(this.expire_time);
          if (now.getTime() > expire_time.getTime())
          {
            clearInterval(interval);
            this.reset = true;
          }
        }.bind(this), 1000);
      }
      else
        return showSystemNoti('danger',check.error);
    },
    async submitResetCode()
    {
      const self = this;
      let check = await this.submitResetCodeFunc({phone : this.phone,code : this.code,password : this.password,re_password : this.re_password});
      if (check.ok)
      {
        return showSystemNoti('success', check.message,function (){
          self.$router.push({path: '/login'})
        });
      }
      else
        return showSystemNoti('danger',check.error);
    }
  },
  watch : {
    reset : function ()
    {
      if (this.reset)
      {
        this.reset = false;
        this.send_code = false;
        this.expire_time = null;
      }
    }
  }
};
</script>

<style scoped>
.login-img
{
  max-width: 100%;
  width: 200px;
  margin: 0 auto;
}
</style>